// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","slider":"slider_slider__yGOZe","imgWrapper":"slider_imgWrapper__1x5+B","image":"slider_image__gUhZO"};